// import { useState } from "react";
import React, { useState } from "react";
import { Typography, Button, Stack, Snackbar, Alert } from "@common-ui/ui";
import { ModalContext } from "../../components/BrowserAlert/modalContext";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import { deleteOrgWorkEvent } from "../../services";

export const RemoveWorkEventDialog = ({
  open,
  handleClose,
  currentOrgId,
  currentWorkEventId,
  setWorkEvents,
  getOrgWorkEvents,
}) => {
  let { handleModal } = React.useContext(ModalContext);
  const [isLoading, setIsLoading] = useState(false);
  const [openToast, setOpenToast] = useState(false);

  const handleRemoveWorkEvent = async () => {
    setIsLoading(true);
    try {
      await deleteOrgWorkEvent(currentOrgId, currentWorkEventId);
      let workEvents = await getOrgWorkEvents(currentOrgId);
      setWorkEvents(workEvents);
      setOpenToast(true);
      handleClose();
      setIsLoading(false);
    } catch (error) {
      if (error.message === "Request failed with status code 405") {
        // return alert("Cannot delete work event having results !");
        return handleModal(
          "Cannot delete work event having results !",
          "Error"
        );
      }
      // alert(error.message);
      handleModal(error.message, "Error");
    }
  };

  const handleCancelClick = () => {
    setIsLoading(false);
    handleClose();
  };

  const handleCloseToast = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpenToast(false);
  };

  return (
    <div>
      <Dialog
        open={open}
        onClose={handleCancelClick}
        aria-labelledby="work-event-remove"
        aria-describedby="work-event-remove-dialog"
        fullWidth
      >
        <DialogContent>
          <Stack alignItems="left">
            <Typography variant="h4">
              Are you sure you want to remove this work event?
            </Typography>
          </Stack>
          <Stack
            direction={{ xs: "column", md: "row" }}
            justifyContent="flex-end"
            spacing={{ xs: 1, md: 2 }}
            sx={{ px: 3, pt: 3 }}
          >
            <div>
              <Button
                color="primary"
                size="small"
                variant="text"
                onClick={handleCancelClick}
              >
                No, Cancel
              </Button>
            </div>
            <div>
              <Button
                color="primary"
                disabled={isLoading}
                size="small"
                variant="contained"
                onClick={handleRemoveWorkEvent}
              >
                Yes, Remove
              </Button>
            </div>
          </Stack>
        </DialogContent>
      </Dialog>
      <Snackbar
        open={openToast}
        autoHideDuration={6000}
        onClose={handleCloseToast}
      >
        <Alert
          onClose={handleCloseToast}
          severity="success"
          sx={{ width: "100%" }}
          variant="filled"
        >
          Work Event has been removed successfully.
        </Alert>
      </Snackbar>
    </div>
  );
};
